import styled from 'styled-components'
import { setPaddingSize } from '../../../utils/contentfulStyles.utils'

export const IconsContainer = styled.div<{
  $topPadding: string
  $bottomPadding: string
  $background: string
  $layout: string
  $columns: string
}>`
  ${({ theme, $topPadding, $bottomPadding, $background, $layout, $columns }) => {
    let paddingStyles = `
      padding-top: ${setPaddingSize($topPadding)}px;
      padding-bottom: ${setPaddingSize($bottomPadding)}px;
    `

    let alignmentStyles = ''
    if ($layout === 'Text to Right') {
      alignmentStyles += `
        .Icons__Item-Container {
          display: flex;
        }

        .Icons__Text-Container {
          padding-left: 24px;
        }

        h6 {
          margin-bottom: 16px;
        }
      `
    } else {
      if ($layout === 'Text Below Centre-aligned') alignmentStyles += `text-align: center;`
      alignmentStyles += `
        h6 {
          margin: 16px 0;
        }
      `
    }

    let themeStyles = ''
    if ($background === 'Dark') {
      themeStyles += `
        background: ${theme.webMktNewPalette.deepBlue[70]};

        a {
          color: #38c6f4;
        }

        p, h6, li {
          color:${theme.webMktNewPalette.white};
        }
      `
    } else {
      themeStyles += `
        ${$background === 'Grey' ? `background: ${theme.webMktNewPalette.deepBlue[10]};` : ''}

        p, h6, li {
          color: ${theme.webMktNewPalette.black};
        }
      `
    }

    let columnsStyles = `
      .Icons__Outer-Container {
        ${
          $columns === '5'
            ? `${theme.breakpoints.up('lg')} {
                  max-width: 996px;
                }
              `
            : ''
        }

        margin: 0 auto;
        margin-top: -48px;

        ${theme.breakpoints.down('sm')} {
          margin-top: -32px;
        }
      }

      ${theme.breakpoints.down('sm')} {
        .Icons__Inner-Container {
          width: calc(100% + 16px);
          margin: 0 -8px;
        }

        .Icons__Item-Container {
          padding: 0 8px;
        }
      }
    `

    if ($columns === '3') {
      columnsStyles += `
        ${theme.breakpoints.up('lg')} {
          .Icons__Inner-Container {
            width: calc(100% + 38px);
            margin: 0 -19px;
          }

          .Icons__Item-Container {
            padding: 0 19px;
          }
        }
      `
    }

    if ($columns === '5') {
      columnsStyles += `
        ${theme.breakpoints.up('sm')} {
          .Icons__Item-Container {
            flex-grow: 0;
            max-width: 20%;
            flex-basis: 20%;
          }
          .IconText--fullWidth{
          .Icons__Item-Container {
            flex-grow: 0;
            max-width: 33.333333%;
            flex-basis: 33.333333%;
        }
      }
        }
      `
    }

    if ($columns !== '5' && $columns !== '6') {
      columnsStyles += `
        .Icons__Outer-Container {
          ${theme.breakpoints.down('xs')} {
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      `
    }

    return `
      overflow: hidden;
      ${paddingStyles}
      ${alignmentStyles}
      ${themeStyles}
      ${columnsStyles}
.IconText--Events.Icons__Outer-Container {
  margin: 0 auto;
  max-width:initial;
  margin:0 167px;
  ${theme.breakpoints.down('lg')} {
  margin:0 48px;
  }
  ${theme.breakpoints.down('md')} {
    margin:0px;
    }
  .Icons__Item-Container {
    border-right: 1px solid ${theme.webMktNewPalette.deepBlue[35]};
    padding: 96px 48px;
    margin-top: 0;
    border-bottom:1px solid ${theme.webMktNewPalette.deepBlue[35]};
    display:flex;
    text-align:left;
     ${theme.breakpoints.down('md')} {
     padding:56px 32px;
     }
     ${theme.breakpoints.down('sm')} {
     flex-direction:column;
     }
     ${theme.breakpoints.down('xs')} {
      padding:32px 16px;
      border-right:none;
      }
    &:nth-child(3n) {
      border-right: none;
       ${theme.breakpoints.down('sm')} {
       border-right: 1px solid ${theme.webMktNewPalette.deepBlue[35]};
       }
       ${theme.breakpoints.down('xs')} {
       border-right:none;
       }
    }
    &:nth-child(2n) {
     ${theme.breakpoints.down('sm')} {
       border-right: none;
       }
    }
      &:nth-last-child(-n+3) {
       border-bottom:none;
       ${theme.breakpoints.down('sm')} {
        border-bottom: 1px solid ${theme.webMktNewPalette.deepBlue[35]};
        }
      }
      &:nth-last-child(-n+2) {
     ${theme.breakpoints.down('sm')} {
       border-bottom: none;
       }
       ${theme.breakpoints.down('xs')} {
        border-bottom: 1px solid ${theme.webMktNewPalette.deepBlue[35]};
        border-right:none;
        }
    }
        &:last-child {
         ${theme.breakpoints.down('xs')} {
         border-bottom:none;
         }
        }
       img{
       width:96px;
       height:96px;
       }
       .Icons__Text-Container{
       padding-left:24px;
       ${theme.breakpoints.down('sm')} {
       padding-left:0;
  }
       p{
        ${theme.breakpoints.down('sm')} {
       font-size:14px;
  }
       }
       .Icons__Title{
       font-size:36px;
       line-height:44px;
       letter-spacing:-2px;
       font-weight:600;
       margin-bottom:8px;
        ${theme.breakpoints.down('md')} {
        font-size:24px;
       line-height:28px;
       letter-spacing:-1px;
        }
       ${theme.breakpoints.down('xs')} {
       font-size:22px;
       letter-spacing:-normal;
       }
       }
       ul{
       padding-bottom:0;
       }
  }
  }
}


.IconText--Events.Icons__Outer-Container.IconsLength3{
  .Icons__Item-Container{
   ${theme.breakpoints.down('sm')} {border-bottom:1px solid ${theme.webMktNewPalette.deepBlue[35]};}
    &:last-child {border-bottom:none;}
  }
}


.IconText--Events.Icons__Outer-Container.IconsLength4{
  .Icons__Item-Container{
    border-bottom:1px solid ${theme.webMktNewPalette.deepBlue[35]};
    &:nth-last-child(-n+2) {
       ${theme.breakpoints.down('sm')} {border-bottom:none;}
       ${theme.breakpoints.down('xs')} {border-bottom:1px solid ${
      theme.webMktNewPalette.deepBlue[35]
    };}
    }
    &:last-child {border-bottom:none;}
  }
}
.IconText--Events.Icons__Outer-Container.IconsLength5{
    .Icons__Item-Container{
      border-bottom:1px solid ${theme.webMktNewPalette.deepBlue[35]};
      &:nth-last-child(-n+2) {
        border-bottom:none;
        ${theme.breakpoints.down('sm')} {border-bottom:1px solid ${
      theme.webMktNewPalette.deepBlue[35]
    };}
      }
      &:last-child {border-bottom:none;}
    }
  }

.IconText--Events.Icons__Outer-Container.IconsLength2{
    .Icons__Inner-Container{
      justify-content:center;
      .Icons__Item-Container{    
        &:last-child {border-bottom:none; border-right:none}
      }
    }
  }

  .IconText--Events.Icons__Outer-Container.IconsLength1{
    .Icons__Inner-Container{
      justify-content:center;
      .Icons__Item-Container{    
        &:last-child {border-bottom:none; border-right:none}
      }
    }
  }






  .IconText--fullWidth.Icons__Outer-Container {
  max-width: 1374px;
  text-align: left;
  background-color: transparent;

  ${theme.breakpoints.down('xs')} {
    margin-top: 0;
  }

  .MuiGrid-spacing-xs-3 {
    margin: -12px 0;
    .MuiGrid-item {
      padding: 24px 24px 24px 0;
    }
  }

  .Icons__Inner-Container {
    ${theme.breakpoints.down('xs')} {
      width: 100%;
      margin: 0;
    }
  }

  .Icons__Item-Container {
    display: initial;

    img {
      margin-bottom: 8px;
    }

    .Icons__Text-Container {
      padding-left: 0;

      .Icons__Title {
        font-size: 24px;
        line-height: 32px;
        letter-spacing: -1px;
        font-weight: 600;
      }

      p {
        a {
          margin-top: 8px;
          display: block;
          color: ${theme.webMktNewPalette.action.light.primary};

          &:hover {
            color: ${theme.webMktPalette.text.actionLightHover};
          }
        }
      }
    }
  }
}

      
      .Icons__Outer-Container {
        ${themeStyles}
        ${theme.breakpoints.down('xs')} {
          max-width: 328px;
        }
      }

      .Icons__Item-Container {
        padding-top: 0;
        padding-bottom: 0;
        margin-top: 48px;

        img {
          height: 64px;
          width: 64px;
          object-fit: contain;
          margin-bottom:24px;
        }

        ${theme.breakpoints.down('sm')} {
          margin-top: 32px;
        }
      }

      .Icons__Text-Container {
        .Icons__Title {
          margin: 0 0 16px;
        }

        p {
          margin: 0;
        }

        ul {
          list-style: disc;
          padding-left: 24px;
          margin-top: 16px;
        }

        li {
          margin: 0 0 8px;
        }
      }

      .Icon__CTA {
        margin-top: 16px;
      }
    `
  }}
`
